import { render } from "./laborPracticeMuseum.vue?vue&type=template&id=e8eb7bbc&scoped=true"
import script from "./laborPracticeMuseum.vue?vue&type=script&lang=js"
export * from "./laborPracticeMuseum.vue?vue&type=script&lang=js"

import "./laborPracticeMuseum.vue?vue&type=style&index=0&id=e8eb7bbc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8eb7bbc"]])

export default __exports__